import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "../assets/css/Login.css";
import { toFollowEst, toggleLoginScreen, clearFollowIntent } from "../actions/AccountAction";
import { updateAccountInfo } from "../actions/index";
import Icon from "@identitybuilding/idb-react-iconlib";
import {
  OsnInputDate,
  OsnInputText,
  OsnSelect,
} from "@identitybuilding/idb-react-ui-elements";
import axios from "axios";
import CustomDualListBox from "../components/CustomDualListbox";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { not } from "ajv/dist/compile/codegen";
import Select, { components } from "react-select";
import AsyncCreatableSelect from "react-select/async-creatable";
import DualListBox from "react-dual-listbox";
import "react-dual-listbox/lib/react-dual-listbox.css";
import { getEnvEndpoints } from "../utils/functions";

// function useForceUpdate() {
//     const [value, setValue] = useState(0); // integer state
//     return () => setValue(value => value + 1); // update state to force render
//     // An function that increment 👆🏻 the previous state like here
//     // is better than directly setting `value + 1`
// }

const Login = (props) => {
  // const forceUpdate = useForceUpdate();
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    swipeToSlide: true,
  };
  const history = useHistory();
  const [paperPreference, setPaperPreference] = useState(null); // 'physical_only', 'digital_only', 'both', or null
  const [isPaperVersionText2, setIsPaperVersionText2] = useState(false);
  const [isPaperVersionText3, setIsPaperVersionText3] = useState(false);
  const [notFromBelgium, setNotFromBelgium] = useState(false);
  const [municipality, setMunicipality] = useState(null);
  const [provinces, setProvinces] = useState([]);

  const [municipalityFollowing, setMunicipalityFollowing] = useState([]);
  const [provinceFollowing, setProvinceFollowing] = useState([]);
  const autoAddedMunicipalityRef = useRef(null);
  const manuallyEditedRef = useRef(false);

  const [municipalities, setMunicipalities] = useState([]);
  const [country, setCountry] = useState("");
  const dispatch = useDispatch();
  const { translate, lang } = useSelector((state) => state.general);
  const { toFollowEstablishment, accountData, followIntent } = useSelector(
    (state) => state.account
  );
  const isUpdateFollowsMode = !!(accountData && followIntent);
  const [loginType, setLoginType] = useState("login");
  const [error, setError] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");

  const [zoomIn, setZoomIn] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  const [viewPassword1, setViewPassword1] = useState(false);
  const [viewPassword2, setViewPassword2] = useState(false);
  const [viewPassword3, setViewPassword3] = useState(false);
  const [viewPassword4, setViewPassword4] = useState(false);
  const [viewPassword5, setViewPassword5] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);

  const [userType, setUserType] = useState("consumer");
  const [accountInformation, setAccountInformation] = useState(false);
  // const [preferred_language, setPreferred_language] = useState(lang === 'nl' ? { id: 'nl', name: 'Nederlands' } : { id: 'fr', name: 'Français' });

  // login states
  const [LoginEmailUsername, setLoginEmailUsername] = useState("");
  const [LoginPassword, setLoginPassword] = useState("");

  // register states
  // consumer
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [registerRepeatPassword, setRegisterRepeatPassword] = useState("");
  // business
  const [registerEstablishmentNumber, setRegisterEstablishmentNumber] =
    useState("");
  const [registerEnterpriseNumber, setRegisterEnterpriseNumber] = useState("");
  const [registerOtp, setRegisterOtp] = useState("");
  const [seePassword, setSeePassword] = useState(false);

  // extra info register
  const [registerUsername, setRegisterUsername] = useState("");
  const [registerFirstName, setRegisterFirstName] = useState("");
  const [registerLastName, setRegisterLastName] = useState("");
  const [registerDateOfBirth, setRegisterDateOfBirth] = useState("");
  const [registerTelephone, setRegisterTelephone] = useState("");
  const [registerCountry, setRegisterCountry] = useState("");

  const [registerMunicipality, setRegisterMunicipality] = useState("");
  const [searchTerm, setSearchTerm] = useState(""); // Add this state at the top of your component
  const env = getEnvEndpoints();


  // Registration type (private/company)
  const [registrationType, setRegistrationType] = useState("private")
  const [vatNumber, setVatNumber] = useState("")

  //exra address fields
  const [street, setStreet] = useState("")
  const [houseNumber, setHouseNumber] = useState("")
  const [bus, setBus] = useState("")
  const [postcode, setPostCode] = useState("")
  const [gemeente, setGemeente] = useState("")
  // Configuration for slider images from FTP
  const TREES_INFO_BASE_URL = "https://o-sn.be/seg/app-files";

  const [deelgemeente, setDeelgemeente] = useState("")

  // Address auto-fill state
  const [subMunicipalityOptions, setSubMunicipalityOptions] = useState([])
  const [selectedStreet, setSelectedStreet] = useState(null)
  const [selectedSubMunicipality, setSelectedSubMunicipality] = useState(null)
  const [addressAutoFilled, setAddressAutoFilled] = useState(false)
  const postalCodeTimerRef = useRef(null)

  const preferredLanguageOptions = [
    { id: "nl", value: "nl", label: "Nederlands" },
    { id: "fr", value: "fr", label: "Français" },
    { id: "en", value: "en", label: "English" },
    { id: "de", value: "de", label: "Deutsch" },
  ];

  const [preferred_language, setPreferred_language] = useState(
    preferredLanguageOptions[0]
  ); // Defaults to the first option

  // 🟢 Sync dropdown with Redux language
  useEffect(() => {
    const selected = preferredLanguageOptions.find((opt) => opt.value == lang);
    if (selected) {
      setPreferred_language(selected);
    }
  }, [lang]);

  const handleLanguageChange = (selected) => {
    setPreferred_language(selected); // Ensure it directly updates with the selected option
  };

  // Address auto-fill: lookup by postal code
  const handlePostalCodeChange = (value) => {
    setPostCode(value);
    setError("");

    // Clear previous timer
    if (postalCodeTimerRef.current) {
      clearTimeout(postalCodeTimerRef.current);
    }

    // If user clears postal code, reset auto-filled fields
    if (!value || value.length < 4) {
      setAddressAutoFilled(false);
      setGemeente("");
      setDeelgemeente("");
      setSubMunicipalityOptions([]);
      setSelectedSubMunicipality(null);
      setSelectedStreet(null);
      setStreet("");
      return;
    }

    // When 4 digits, debounce and lookup
    if (value.length === 4 && /^\d{4}$/.test(value)) {
      postalCodeTimerRef.current = setTimeout(async () => {
        try {
          const response = await axios.get(
            `${env.REACT_APP_BASE_MEDIA_URL}/geo/api/address-lookup/?postal_code=${value}&lang=${lang}`
          );
          const data = response.data;

          if (data.municipality) {
            setGemeente(data.municipality.name);
            setAddressAutoFilled(true);
          } else {
            setAddressAutoFilled(false);
            setGemeente("");
          }

          if (data.sub_municipalities && data.sub_municipalities.length > 0) {
            const options = data.sub_municipalities.map(sm => ({
              value: sm.id,
              label: sm.name,
            }));
            setSubMunicipalityOptions(options);

            if (data.sub_municipalities.length === 1) {
              setDeelgemeente(data.sub_municipalities[0].name);
              setSelectedSubMunicipality(options[0]);
            } else {
              setDeelgemeente("");
              setSelectedSubMunicipality(null);
            }
          } else {
            setSubMunicipalityOptions([]);
            setDeelgemeente("");
            setSelectedSubMunicipality(null);
          }

          // Reset street when postal code changes
          setSelectedStreet(null);
          setStreet("");
        } catch (err) {
          console.error("Address lookup failed:", err);
          setAddressAutoFilled(false);
        }
      }, 400);
    }
  };

  // Address auto-fill: street typeahead
  const [streetOptions, setStreetOptions] = useState([])

  const loadStreetOptions = async (inputValue) => {
    if (!postcode || postcode.length !== 4) {
      return [];
    }
    // Require either a sub-municipality or 2+ chars typed
    if (!selectedSubMunicipality && inputValue.length < 2) {
      return [];
    }
    try {
      let url = `${env.REACT_APP_BASE_MEDIA_URL}/geo/api/address-lookup/?postal_code=${postcode}&lang=${lang}`;
      if (selectedSubMunicipality) {
        url += `&sub_municipality_id=${selectedSubMunicipality.value}`;
      }
      if (inputValue.length >= 2) {
        url += `&street_search=${encodeURIComponent(inputValue)}`;
      }
      const response = await axios.get(url);
      const options = (response.data.streets || []).map(s => ({
        value: s.id,
        label: s.name,
      }));
      return options;
    } catch (err) {
      console.error("Street search failed:", err);
      return [];
    }
  };

  // Load streets when sub-municipality is selected
  useEffect(() => {
    if (addressAutoFilled && postcode && postcode.length === 4 && selectedSubMunicipality) {
      const fetchStreets = async () => {
        try {
          const url = `${env.REACT_APP_BASE_MEDIA_URL}/geo/api/address-lookup/?postal_code=${postcode}&sub_municipality_id=${selectedSubMunicipality.value}&lang=${lang}`;
          const response = await axios.get(url);
          const options = (response.data.streets || []).map(s => ({
            value: s.id,
            label: s.name,
          }));
          setStreetOptions(options);
        } catch (err) {
          console.error("Street load failed:", err);
          setStreetOptions([]);
        }
      };
      fetchStreets();
    } else {
      setStreetOptions([]);
    }
  }, [selectedSubMunicipality, postcode, addressAutoFilled]);

  const resetValues = () => {
    setRegisterEmail("");
    setRegisterPassword("");
    setRegisterRepeatPassword("");
    setRegisterEstablishmentNumber("");
    setRegisterEnterpriseNumber("");
    setRegisterOtp("");
  };

  const isUpper = (str) => {
    return /[A-Z]/.test(str);
  };
  const hasNumber = (str) => {
    return /[0-9]/.test(str);
  };

  const registerHandler = () => {
    if (userType === "consumer") {
      if (registerEmail === "") {
        props.createNotification("warning", translate("please_enter_an_email"));
        setError("email");
      } else if (registerEmail.split("@").length > 2) {
        props.createNotification("warning", translate("more_than_one_at"));
        setError("email");
      } else if (!/\S+@\S+\.\S+/.test(registerEmail)) {
        props.createNotification("warning", translate("not_a_valid_email"));
        setError("email");
      } else if (registerPassword === "") {
        props.createNotification(
          "warning",
          translate("please_enter_a_password")
        );
        setError("password");
      } else if (registerPassword.length < 8) {
        props.createNotification("warning", translate("password_8_characters"));
        setError("password");
      } else if (!isUpper(registerPassword)) {
        props.createNotification("warning", translate("password_1_capital"));
        setError("password");
      } else if (!hasNumber(registerPassword)) {
        props.createNotification("warning", translate("password_1_number"));
        setError("password");
      } else if (registerRepeatPassword === "") {
        props.createNotification("warning", translate("enter_password_repeat"));
        setError("repeat_password");
      } else if (registerPassword !== registerRepeatPassword) {
        props.createNotification(
          "warning",
          translate("passwords_do_not_match")
        );
        setError("repeat_password");
      } else {
        axios
          .post(
            `${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/check/email/`,
            {
              email: registerEmail.toLowerCase(),
            }
          )
          .then((res) => {
            if (res.data.status === "Ok") {
              setAccountInformation(true);
            } else {
              props.createNotification(
                "warning",
                translate("email_already_in_use")
              );
              setError("email");
            }
          });
      }
    } else {
      if (registerEmail === "") {
        props.createNotification("warning", translate("please_enter_an_email"));
        setError("email");
      } else if (!/\S+@\S+\.\S+/.test(registerEmail)) {
        props.createNotification("warning", translate("not_a_valid_email"));
        setError("email");
      } else if (registerPassword === "") {
        props.createNotification(
          "warning",
          translate("please_enter_a_password")
        );
        setError("password");
      } else if (registerPassword.length < 8) {
        props.createNotification("warning", translate("password_8_characters"));
        setError("password");
      } else if (!isUpper(registerPassword)) {
        props.createNotification("warning", translate("password_1_capital"));
        setError("password");
      } else if (!hasNumber(registerPassword)) {
        props.createNotification("warning", translate("password_1_number"));
        setError("password");
      } else if (registerRepeatPassword === "") {
        props.createNotification("warning", translate("enter_password_repeat"));
        setError("repeat_password");
      } else if (registerPassword !== registerRepeatPassword) {
        props.createNotification(
          "warning",
          translate("passwords_do_not_match")
        );
        setError("repeat_password");
      } else if (registerEnterpriseNumber === "") {
        props.createNotification(
          "warning",
          translate("please_enter_enterprise_number")
        );
        setError("enterprise");
      } else if (registerEstablishmentNumber === "") {
        props.createNotification(
          "warning",
          translate("please_enter_establishment_number")
        );
      } else if (municipalityFollowing.length === 0) {
        props.createNotification(
          "warning",
          translate("please_select_at_least_one_municipality")
        );
        setError("establishment");
      } else {
        // controle op OTP en establishments + enterprise
        axios
          .post(
            `${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/check/email/`,
            {
              email: registerEmail.toLowerCase(),
            }
          )
          .then((res) => {
            if (res.data.status === "Ok") {
              setAccountInformation(true);
            } else {
              props.createNotification(
                "warning",
                translate("email_already_in_use")
              );
              setError("email");
            }
          });
      }
    }
  };
  const routeMap = {
    nl: { collaboration: "/actieve-gemeenten", following: "/wie-volg-ik" },
    fr: { collaboration: "/communes-actives", following: "/mes-suivis" },
    en: { collaboration: "/active-municipalities", following: "/who-i-follow" },
    de: { collaboration: "/aktive-gemeinden", following: "/wer-folge-ich" },
  };
  const routePath_HasCollaboration = routeMap[lang]?.collaboration || routeMap.nl.collaboration;
  const routePath_Following = routeMap[lang]?.following || routeMap.nl.following;

  // const extraRegisterHandler = () => {
  //     if (registerUsername === '') { props.createNotification("warning", translate('please_enter_username')); setError('username') }
  //     else if (registerFirstName === '') { props.createNotification("warning", translate('please_enter_first_name')); setError('prename') }
  //     else if (registerLastName === '') { props.createNotification("warning", translate('please_enter_last_name')); setError('name') }
  //     else {
  //         axios.post(`${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/check/username/`, {
  //             username: registerUsername,
  //         }).then((res) => {
  //             if (res.data.status === 'Ok') {
  //                 axios.post(`${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/confirm/?site=stadgeemente"`, {
  //                     registerEmail: registerEmail,
  //                     registerPassword: registerPassword,
  //                     registerRepeatPassword: registerRepeatPassword,
  //                     registerEstablishmentNumber: registerEstablishmentNumber,
  //                     registerEnterpriseNumber: registerEnterpriseNumber,
  //                     registerOtp: registerOtp,
  //                     registerUsername: registerUsername,
  //                     registerFirstName: registerFirstName,
  //                     registerLastName: registerLastName,
  //                     registerDateOfBirth: registerDateOfBirth,
  //                     registerTelephone: registerTelephone,
  //                     preferred_language: preferred_language,
  //                     userType: userType
  //                 }).then(() => {
  //                     props.createNotification("info", translate('please_confirm_account'))
  //                     setTimeout(() => {
  //                         dispatch(toggleLoginScreen(false))
  //                         dispatch(toFollowEst(""))
  //                     }, 2000);
  //                 })
  //             }
  //             else { props.createNotification("warning", translate('username_already_in_use')); setError('username') }
  //         })

  //     }
  // }
  const updateFollowsHandler = async () => {
    setIsRegistering(true);
    const token = localStorage.getItem("StadGemeenteToken");
    if (!token) {
      setIsRegistering(false);
      return;
    }
    try {
      await axios.post(
        `${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/follow-overview/update/?lang=${lang}`,
        {
          municipality_ids: municipalityFollowing,
          province_ids: provinceFollowing,
          paper_preference: paperPreference,
          digital_registration_message: isPaperVersionText2,
          support_tree_planting_initiative: isPaperVersionText3,
        },
        { headers: { Authorization: `Token ${token}` } }
      );
      // Refresh accountData in Redux so DetailsPage + Preferences page both reflect the update
      const userRes = await axios.get(
        `${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/user/?lang=${lang}`,
        { headers: { Authorization: `Token ${token}` } }
      );
      dispatch(updateAccountInfo(userRes.data));
      dispatch(clearFollowIntent());
      dispatch(toggleLoginScreen(false));
      props.createNotification("success", translate("selections_saved") || "Selecties opgeslagen");
    } catch (err) {
      props.createNotification("error", translate("selections_save_error") || "Opslaan mislukt");
    } finally {
      setIsRegistering(false);
    }
  };

  const extraRegisterHandler = () => {
    setIsRegistering(true);
    if (registerFirstName === "") {
      props.createNotification("warning", translate("please_enter_first_name"));
      setError("prename");
      setIsRegistering(false);
    } else if (registerLastName === "") {
      props.createNotification("warning", translate("please_enter_last_name"));
      setError("name");
      setIsRegistering(false);
    } else if (notFromBelgium && registerCountry === "") {
      props.createNotification("warning", translate("please_select_country"));
      setError("country");
      setIsRegistering(false);
    } else if (!notFromBelgium && registerMunicipality === "") {
      props.createNotification(
        "warning",
        translate("please_select_municipality")
      );
      setError("municipality");
      setIsRegistering(false);
    } else if (
      municipalityFollowing.length === 0 &&
      provinceFollowing.length === 0
    ) {
      props.createNotification(
        "warning",
        translate("please_select_at_least_one_municipality_to_follow")
      );
      setError("following_municipalities");
      setIsRegistering(false);
      }else if (paperPreference && paperPreference !== 'none' && (!street || street.trim().length < 2)) {
        props.createNotification("warning", "Het straat veld moet worden ingevuld");
        setError("street");
        setIsRegistering(false);
      } else if (paperPreference && paperPreference !== 'none' && (!houseNumber || houseNumber.trim() === "")) {
        props.createNotification("warning", "Het huisnummer veld moet worden ingevuld");
        setError("houseNumber");
        setIsRegistering(false);
      } else if (paperPreference && paperPreference !== 'none' && (!postcode || postcode.trim() === "")) {
        props.createNotification("warning", "Post code ingevuld");
        setError("postcode");
        setIsRegistering(false);
      } else if (paperPreference && paperPreference !== 'none' && postcode.length !== 4) {
        props.createNotification("warning", "Een postcode bestaat uit 4 cijfers");
        setError("postcode");
        setIsRegistering(false);
      } else if (paperPreference && paperPreference !== 'none' && !/^\d+$/.test(postcode)) {
        props.createNotification("warning", "Postcode mag enkel cijfers bevatten");
        setError("postcode");
        setIsRegistering(false);
      } else if (paperPreference && paperPreference !== 'none' && (!gemeente || gemeente.trim() === "")) {
        props.createNotification("warning", "Het stad/gemeente veld moet worden ingevuld");
        setError("gemeente");
        setIsRegistering(false);
      } else if (registrationType === 'company' && (!vatNumber || vatNumber.trim() === "")) {
        props.createNotification("warning", translate("vat_number_required"));
        setError("vatNumber");
        setIsRegistering(false);
      } else if (registrationType === 'company' && !/^BE\d{10}$/.test(vatNumber.trim().replace(/[.\s]/g, ''))) {
        props.createNotification("warning", translate("vat_number_invalid"));
        setError("vatNumber");
        setIsRegistering(false);
      } else {
      axios
        .post(
          `${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/check/email/`,
          {
            email: registerEmail.toLowerCase(),
          }
        )
        .then((res) => {
          if (res.data.status === "Ok") {
            // Proceed with registration
            axios
              .post(
                `${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/register/`,
                {
                  registerEmail: registerEmail.toLowerCase(),
                  registerPassword: registerPassword,
                  registerRepeatPassword: registerRepeatPassword,
                  registerEstablishmentNumber: registerEstablishmentNumber,
                  registerEnterpriseNumber: registerEnterpriseNumber,
                  registerFirstName: registerFirstName,
                  registerLastName: registerLastName,
                  registerTelephone: registerTelephone,
                  preferred_language: preferred_language,
                  registerNotFromBelgium: notFromBelgium,
                  registerMunicipality: municipality,
                  registerProvince: provinceFollowing,
                  registerCountry: registerCountry,
                  userType: userType,
                  followingMunicipalities: municipalityFollowing,
                  paperPreference: paperPreference,
                  digital_registration_message: isPaperVersionText2,
                  support_tree_planting_initiative: isPaperVersionText3,
                  postal_code: postcode,
                  house_number: houseNumber,
                  municipality: gemeente,
                  street: street,
                  box: bus,
                  sub_municipality: deelgemeente,
                  registration_type: registrationType,
                  vat_number: registrationType === 'company' ? vatNumber : '',
                }
              )
              .then(() => {
                props.createNotification(
                  "success",
                  translate("registration_successful")
                );

                // Automatically log in the user
                axios
                  .post(
                    `${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/login/`,
                    {
                      emailUsername: registerEmail.toLowerCase(),
                      password: registerPassword,
                    }
                  )
                  .then((loginRes) => {
                    localStorage.setItem(
                      "StadGemeenteToken",
                      loginRes.data.token
                    );
                    dispatch(toggleLoginScreen(false));
                    dispatch(toFollowEst(""));
                    dispatch({ type: "TOGGLE_LOGGED_IN_STATE", value: true });
                    // window.location.reload(true); // Refresh the page to reflect login state
                    dispatch({ type: "TOGGLE_FOLLOW_STATE", value: true });
                    // Redirect back to bosuitbreiding page if that's where we came from
                    const currentPath = window.location.pathname + window.location.search;
                    if (currentPath.includes('bosuitbreiding')) {
                      window.location.reload();
                    } else {
                      window.location.href = routePath_Following;
                    }
                  })
                  .catch((err) => {
                    console.error("Login after registration failed:", err);
                    props.createNotification(
                      "error",
                      translate("login_failed")
                    );
                  })
                  .finally(() => {
                    setIsRegistering(false); // Stop loader
                  });
              })
              .catch((err) => {
                props.createNotification(
                  "error",
                  translate("registration_failed")
                );
                console.error(err);
                setIsRegistering(false);
              });
          } else {
            props.createNotification(
              "warning",
              translate("username_already_in_use")
            );
            setError("username");
            setIsRegistering(false);
          }
        })
        .catch((err) => {
          props.createNotification("error", translate("username_check_failed"));
          console.error(err);
          setIsRegistering(false);
        });
    }
  };

  const followHandler = () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${localStorage.getItem("StadGemeenteToken")}`,
    };
    axios
      .post(
        `${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/follow_establishment/${toFollowEstablishment}?lang=${lang}`,
        {
          headers: headers,
          token: localStorage.getItem("StadGemeenteToken"),
          following: true,
        }
      )
      .then(() => {})
      .catch((err) => {
        if (err.response.data.Status === "Duplicate group") {
          // dispatch(toggleOpenFollowingConflict(err.response.data.establishment))
        }
      });
  };

  const loginHandler = () => {
    axios
      .post(`${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/login/`, {
        emailUsername: LoginEmailUsername.toLowerCase(),
        password: LoginPassword,
      })
      .then((res) => {
        localStorage.setItem("StadGemeenteToken", res.data.token);
        followHandler();
        dispatch({ type: "TOGGLE_LOGGED_IN_STATE", value: true });
        dispatch({ type: "TOGGLE_FOLLOW_STATE", value: true });
        setTimeout(() => {
          const currentPath = window.location.pathname + window.location.search;
          if (currentPath.includes('bosuitbreiding')) {
            window.location.reload();
          } else {
            window.location.href = routePath_Following;
          }
        }, 500);
        dispatch({ type: "TOGGLE_FOLLOW_STATE", value: true });
      })
      .catch((error) => {
        console.error(error);
        setError("login");
      });
  };

  const forgotHandler = () => {
    if (forgotEmail === "") {
      props.createNotification("warning", translate("please_enter_an_email"));
      setError("repeat_password");
    } else {
      axios
        .post(
          `${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/forgot/?site=stad-gemeente`,
          {
            emailUsername: forgotEmail.toLowerCase(),
          }
        )
        .then((res) => {
          props.createNotification(
            "info",
            translate("check_mail_password_reset")
          );
        })
        .catch((error) => {
          props.createNotification("warning", "Opgegeven email bestaat niet");
        });
    }
  };

  const keyDownHandler = (e) => {
    // if (e.keyCode === 13) { loginHandler() }
  };

  useEffect(() => {
    document.addEventListener("keydown", keyDownHandler);
  });

  // Generate array of 7 slider image URLs based on current language
  const sliderImages = Array.from({ length: 7 }, (_, i) => {
    const paddedNumber = (i + 1).toString().padStart(2, '0');
    return `${TREES_INFO_BASE_URL}/${lang}/trees-info_${lang}_${paddedNumber}.svg`;
  });


  useEffect(() => {
    // Fetch municipalities when the component mounts
    const fetchMunicipalities = async () => {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ae0e4f2df7b0d54ce458ca65ca53849e92691e86`,
      };
      try {
        const response = await axios.get(
          `${env.REACT_APP_BASE_MEDIA_URL}/core/new-api/geo/municipality/?fields=id,nis_code,name_nl,name_fr,name_de,name_en&paginate=false&ordering=name_nl,name_fr,name_de,name_en`,
          { headers }
        );
        if (response.data) {
          // Map response to format required by OsnSelect
          const municipalitiesOptions = response.data.map((item) => {
            var name =
              (item.name_nl &&
                item.name_fr &&
                `${item.name_nl} / ${item.name_fr}`) ||
              item.name_nl ||
              item.name_fr ||
              item.name_de ||
              item.name_en ||
              "Unknown"; // Fallback for missing data
            if (name.toLowerCase().startsWith("'s")) {
              name = name.replace(/^'s\s*/i, ""); // Remove leading `'s`
            }

            return {
              id: item.id,
              nis_code: item.nis_code,
              name: name,
            };
          });
          municipalitiesOptions.sort((a, b) => a.name.localeCompare(b.name));

          setMunicipalities(municipalitiesOptions);
        }
      } catch (error) {
        console.error("Error fetching municipalities:", error);
      }

      // Fetch provinces
      const fetchProvinces = async () => {
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Token ae0e4f2df7b0d54ce458ca65ca53849e92691e86`,
        };
        try {
          const response = await axios.get(
            `${env.REACT_APP_BASE_MEDIA_URL}/core/new-api/geo/province/?fields=id,name&paginate=false&ordering=name`,
            { headers }
          );
          if (response.data) {
            const provinceOptions = response.data.map((item) => ({
              id: item.id,
              name: item.name,
            }));

            setProvinces(provinceOptions);
          }
        } catch (error) {
          console.error("Error fetching provinces:", error);
        }
      };

      fetchProvinces();
    };

    fetchMunicipalities();
  }, []);

  // When opened in "update follows" mode (logged-in user clicked follow on a DetailsPage),
  // jump straight to the extra-info screen and pre-fill from accountData.
  useEffect(() => {
    if (!isUpdateFollowsMode) return;
    setLoginType("register");
    setAccountInformation(true);

    // Pre-fill personal fields
    setRegisterFirstName(accountData.first_name || "");
    setRegisterLastName(accountData.last_name || "");
    setRegisterTelephone(accountData.telephone || "");
    setRegistrationType(accountData.registration_type || "private");
    setNotFromBelgium(!!accountData.not_from_belgium);

    // Pre-fill home municipality dropdown
    if (accountData.municipality_id) {
      setMunicipality(accountData.municipality_id);
      setRegisterMunicipality(accountData.municipality_id);
    }

    // Pre-fill address fields
    if (accountData.postal_code) setPostCode(accountData.postal_code);
    if (accountData.street) {
      setStreet(accountData.street);
      setSelectedStreet({ value: accountData.street, label: accountData.street });
    }
    if (accountData.house_number) setHouseNumber(accountData.house_number);
    if (accountData.box) setBus(accountData.box);
    if (accountData.sub_municipality) setDeelgemeente(accountData.sub_municipality);
    if (accountData.home_municipality?.name) setGemeente(accountData.home_municipality.name);

    // Pre-fill the 4 registration preferences
    if (accountData.paper_preference) {
      setPaperPreference(accountData.paper_preference);
    }
    setIsPaperVersionText2(!!accountData.digital_registration_message);
    setIsPaperVersionText3(!!accountData.support_tree_planting_initiative);

    // Pre-fill followed municipalities from picker_state
    const currentMuniIds = accountData.picker_state?.municipality_ids || [];
    const currentProvIds = accountData.picker_state?.province_ids || [];

    // Find the municipality ID for the newly-followed municipality (from NIS code)
    if (followIntent?.nisCode && municipalities.length > 0) {
      const newMuni = municipalities.find((m) => m.nis_code === followIntent.nisCode);
      if (newMuni && !currentMuniIds.includes(newMuni.id)) {
        setMunicipalityFollowing([...currentMuniIds, newMuni.id]);
        setHighlightedMunicipalityId(newMuni.id);
      } else {
        setMunicipalityFollowing(currentMuniIds);
      }
    } else {
      setMunicipalityFollowing(currentMuniIds);
    }
    setProvinceFollowing(currentProvIds);

    // Scroll to the municipality picker so the user sees the relevant section first.
    setTimeout(() => {
      const picker = document.querySelector('.following-municipality-select-wrapper');
      if (picker) {
        picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 400);
  }, [isUpdateFollowsMode, municipalities.length, provinces.length]);

  const [highlightedMunicipalityId, setHighlightedMunicipalityId] = useState(null);

  const filteredMunicipalities = municipalities
    .filter((m) => m.name.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => {
      const searchLower = searchTerm.toLowerCase();
      const aIndex = a.name.toLowerCase().indexOf(searchLower);
      const bIndex = b.name.toLowerCase().indexOf(searchLower);
      if (aIndex === bIndex) {
        return a.name.localeCompare(b.name);
      }
      return aIndex - bIndex;
    });

  const optionsForMunicipality = filteredMunicipalities.map((m) => ({
    value: m.id,
    label: m.name,
  }));
  const optionsForFollowingMunicipalities = municipalities.map((m) => ({
    value: m.id,
    label: m.name,
  }));
  const optionsForFollowingProvinces = provinces.map((p) => ({
    value: p.id,
    label: p.name,
  }));

  const handleFollowingProvinceChange = (selected) => {
    setProvinceFollowing(selected); // Updating state for provinces
  };

  // Find the currently selected option
  const selectedOption =
    optionsForMunicipality.find((option) => option.value === municipality) ||
    null;

  // const handleChange = (selected) => {
  //     // Set the selected municipality ID
  //     setMunicipality(selected ? selected.value : null);
  //     setRegisterMunicipality(selected ? selected.value : null);
  // };

  const handleChange = (selected) => {
    setMunicipality(selected ? selected.value : null);
    setRegisterMunicipality(selected ? selected.value : null);
    setSearchTerm(""); // Clear the search term after selecting a municipality

    // Auto-add to municipalities following, replacing the previous auto-added one
    if (selected) {
      const previousAutoAdded = autoAddedMunicipalityRef.current;
      autoAddedMunicipalityRef.current = selected.value;

      setMunicipalityFollowing((prev) => {
        let updated = prev;
        // Only remove the previous auto-added one if user hasn't manually edited the list
        if (!manuallyEditedRef.current && previousAutoAdded && previousAutoAdded !== selected.value) {
          updated = updated.filter((id) => id !== previousAutoAdded);
        }
        // Add the new one if not already present
        if (!updated.includes(selected.value)) {
          updated = [...updated, selected.value];
        }
        return updated;
      });
    } else {
      // Cleared the dropdown — remove the auto-added one
      const previousAutoAdded = autoAddedMunicipalityRef.current;
      autoAddedMunicipalityRef.current = null;

      if (previousAutoAdded && !manuallyEditedRef.current) {
        setMunicipalityFollowing((prev) =>
          prev.filter((id) => id !== previousAutoAdded)
        );
      }
    }
  };
  const handleFollowingMunicipalityChange = (selected) => {
    manuallyEditedRef.current = true;
    setMunicipalityFollowing(selected);
  };

  return (
    <div id="login_wrapper">
      <link
        rel="stylesheet"
        href="//use.fontawesome.com/releases/v5.6.3/css/all.css"
      ></link>
      <div className="login_content">
        <Icon
          className={`close_icon ${zoomIn ? "zoom" : ""}`}
          name="Close"
          onClick={() => {
            dispatch(toggleLoginScreen(false));
            dispatch(toFollowEst(""));
          }}
        />
        <figure>
          <img
            src={
              `https://media.100procentlokaal.be/media/locations/brand/h/mijnstad-gemeente_${lang}.svg`
            }
            alt="logo"
          />
        </figure>
        {/* {accountInformation ?
                    <h2>bedankt om <span style={{ "color": "var(--pn)" }}>&nbsp;jouw account&nbsp;</span>te bevestigen!</h2>
                    : */}
        {(() => {
          const welcomeMap = {
            nl: { text: "Welkom op", highlight: "Mijn Stad Gemeente" },
            fr: { text: "BIENVENUE DANS MA VILLE", highlight: "COMMUNE" },
            en: { text: "Welcome to", highlight: "City Municipality" },
            de: { text: "Willkommen bei", highlight: "Stadt Gemeinde" },
          };
          const w = welcomeMap[lang] || welcomeMap.nl;
          return (
            <h2>
              {w.text}{" "}
              <span style={{ color: "var(--cn)" }}>&nbsp;{w.highlight}</span>
            </h2>
          );
        })()}
        {/* } */}
        {accountInformation ? (
          <div className="login_extra_info">
            {(() => {
              const extraInfoMap = {
                nl: { before: "Vul hieronder nog wat", highlight: "gegevens", after: "van je aan" },
                fr: { before: "Remplissez certaines", highlight: "de vos coordonnées", after: "ci-dessous" },
                en: { before: "Please fill in some", highlight: "details", after: "below" },
                de: { before: "Bitte füllen Sie unten einige", highlight: "Angaben", after: "aus" },
              };
              const info = extraInfoMap[lang] || extraInfoMap.nl;
              return (
                <h2>
                  {info.before}{" "}
                  <span style={{ color: "var(--cn)" }}>&nbsp;{info.highlight}&nbsp;</span>
                  {info.after}
                </h2>
              );
            })()}

            <div className="login_extra_info_fields">
              <div className="registration_type_toggle">
                <label>{translate('i_register_as')}:</label>
                <div className="registration_type_options">
                  <label className={`registration_type_option ${registrationType === 'private' ? 'active' : ''}`}>
                    <input type="radio" name="registrationType" value="private" checked={registrationType === 'private'} onChange={() => { setRegistrationType('private'); setVatNumber(''); setError(''); }} />
                    {translate('private_person')}
                  </label>
                  <label className={`registration_type_option ${registrationType === 'company' ? 'active' : ''}`}>
                    <input type="radio" name="registrationType" value="company" checked={registrationType === 'company'} onChange={() => { setRegistrationType('company'); setError(''); }} />
                    {translate('company_registration')}
                  </label>
                </div>
              </div>
              <OsnInputText
                error={error === "prename" ? true : false}
                className={`firstname half ${
                  window.location.href.includes("mijn.stad-gemeente.be") ||
                  window.location.href.includes("ma.ville-commune.be") ||
                  window.location.href.includes("city-municipality.be") ||
                  window.location.href.includes("stadt-gemeinde.be") ||
                  window.location.href.includes("localhost")
                    ? "inputBorder"
                    : ""
                }`}
                icon="Info"
                title={`${translate("ci_prename")}*`}
                value={registerFirstName}
                onChange={(e) => {
                  setRegisterFirstName(e.target.value);
                  setError("");
                }}
              />
              <OsnInputText
                error={error === "name" ? true : false}
                className={`lastname half ${
                  window.location.href.includes("mijn.stad-gemeente.be") ||
                  window.location.href.includes("ma.ville-commune.be") ||
                  window.location.href.includes("city-municipality.be") ||
                  window.location.href.includes("stadt-gemeinde.be") ||
                  window.location.href.includes("localhost")
                    ? "inputBorder"
                    : ""
                }`}
                icon="Info"
                title={`${translate("ci_lastname")}*`}
                value={registerLastName}
                onChange={(e) => {
                  setRegisterLastName(e.target.value);
                  setError("");
                }}
              />
              <div className="language-container">
                <label className="pref_language">
                  {translate("preferred_language")}
                </label>
                <Select
                  className="lang-select"
                  value={preferred_language}
                  onChange={handleLanguageChange}
                  options={preferredLanguageOptions}
                  components={{
                    DropdownIndicator: (props) => (
                      <components.DropdownIndicator {...props}>
                        <span
                          style={{
                            fontSize: "12px",
                            transform: "rotate(180deg)",
                          }}
                        >
                          ▲
                        </span>
                      </components.DropdownIndicator>
                    ),
                  }}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      padding: "8px",
                    }),
                    control: (provided, state) => ({
                      ...provided,
                      minHeight: "38px",
                      borderColor: state.isFocused ? "var(--cn)" : "#ccc",
                      boxShadow: state.isFocused
                        ? "0 0 0 1px var(--cn)"
                        : "none",
                      "&:hover": {
                        borderColor: "var(--cn)",
                      },
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? "var(--cn)" : "white",
                      color: state.isFocused ? "white" : "#333",
                      cursor: "pointer",
                      "&:active": {
                        backgroundColor: "var(--cn)",
                        color: "white",
                      },
                    }),
                  }}
                />
              </div>

              <OsnInputText
                className={`telephone half ${
                  window.location.href.includes("mijn.stad-gemeente.be") ||
                  window.location.href.includes("ma.ville-commune.be") ||
                  window.location.href.includes("city-municipality.be") ||
                  window.location.href.includes("stadt-gemeinde.be") ||
                  window.location.href.includes("localhost")
                    ? "inputBorder"
                    : ""
                }`}
                icon="Phone"
                title={translate("phone")}
                maxLength={14}
                value={registerTelephone}
                onChange={(e) => {
                  setRegisterTelephone(e.target.value);
                  setError("");
                }}
              />
              {registrationType === 'company' && (
                <OsnInputText
                  error={error === "vatNumber" ? true : false}
                  className={`vat_number half ${
                    window.location.href.includes("mijn.stad-gemeente.be") ||
                    window.location.href.includes("ma.ville-commune.be") ||
                    window.location.href.includes("city-municipality.be") ||
                    window.location.href.includes("stadt-gemeinde.be") ||
                    window.location.href.includes("localhost")
                      ? "inputBorder"
                      : ""
                  }`}
                  icon="Entrepreneur"
                  title={`${translate("vat_number")}*`}
                  placeholder="BE0123.456.789"
                  value={vatNumber}
                  onChange={(e) => {
                    setVatNumber(e.target.value);
                    setError("");
                  }}
                />
              )}
            </div>
            <div className="municipality-checkbox-row">
              {!notFromBelgium ? (
                <div className="municipality-select-wrapper">
                  <Select
                    className="municipality-select"
                    value={selectedOption}
                    onInputChange={(value) => setSearchTerm(value)}
                    onChange={handleChange}
                    options={filteredMunicipalities.map((m) => ({
                      value: m.id,
                      label: m.name,
                    }))}
                    placeholder={translate("search_municipality_StadGemeente")}
                    isDisabled={notFromBelgium}
                    noOptionsMessage={() => "No municipalities found"}
                    components={{
                      DropdownIndicator: (props) => (
                        <components.DropdownIndicator {...props}>
                          <span
                            style={{
                              fontSize: "12px",
                              transform: "rotate(180deg)",
                            }}
                          >
                            ▲
                          </span>
                        </components.DropdownIndicator>
                      ),
                    }}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        width: "100%",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "8px",
                      }),
                      control: (provided, state) => ({
                        ...provided,
                        minHeight: "38px",
                        borderColor: state.isFocused ? "var(--cn)" : "#ccc",
                        boxShadow: state.isFocused
                          ? "0 0 0 1px var(--cn)"
                          : "none",
                        "&:hover": {
                          borderColor: "var(--cn)",
                        },
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? "var(--cn)" : "white",
                        color: state.isFocused ? "white" : "#333",
                        cursor: "pointer",
                        "&:active": {
                          backgroundColor: "var(--cn)",
                          color: "white",
                        },
                      }),
                    }}
                  />
                </div>
              ) : (
                <div className="country-container">
                  <OsnInputText
                    className="country-input inputBorder"
                    icon="Belgium"
                    title={`${translate("country")}*`}
                    onChange={(e) => setRegisterCountry(e.target.value)}
                  />
                </div>
              )}
              <div className="not-from-belgium">
                <input
                  type="checkbox"
                  id="notFromBelgium"
                  checked={notFromBelgium}
                  onChange={(e) => setNotFromBelgium(e.target.checked)}
                />
                <label htmlFor="notFromBelgium">
                  {translate("not_from_belgium")}
                </label>
              </div>
            </div>

            <div className="is-paper-version-info">
              <img
                className="is-paper-version-info-img"
                src={
                  require("../assets/imgs/saveTree.svg").default
                }
                alt=" logo stadgemeente"
              />
              <p className="is_paper_version_info_text">
                {translate("is_paper_version_info_text")}
              </p>
            </div>
            {selectedOption && !notFromBelgium &&
              <>
                <div className="paper-preference-options">
                  <div className="paper-preference-option">
                    <input
                      type="radio"
                      id="paperPreference_both"
                      name="paperPreference"
                      checked={paperPreference === 'both'}
                      onChange={() => setPaperPreference('both')}
                    />
                    <label htmlFor="paperPreference_both">
                      {translate("paper_preference_both")}
                    </label>
                  </div>
                  <div className="paper-preference-option">
                    <input
                      type="radio"
                      id="paperPreference_digital"
                      name="paperPreference"
                      checked={paperPreference === 'digital_only'}
                      onChange={() => setPaperPreference('digital_only')}
                    />
                    <label htmlFor="paperPreference_digital">
                      {translate("paper_preference_digital_only")}
                    </label>
                  </div>
                </div>
                <div className="is-paper-version-text1">
                  <i htmlFor="is_paper_version_text1">
                    {translate("is_paper_version_text1")}
                  </i>
                </div>
                {paperPreference && paperPreference !== 'none' &&
                  <div className="paper-version-address-fields">
                    {/* Row 1: Postal code, Municipality, Sub-municipality */}
                    <div className="paper-version-row">
                      <OsnInputText
                        error={error === "postalcode" ? true : false}
                        className={`paper-field-postcode ${window.location.href.includes("mijn.stad-gemeente.be") ||
                            window.location.href.includes("ma.ville-commune.be") ||
                            window.location.href.includes("city-municipality.be") ||
                            window.location.href.includes("stadt-gemeinde.be") ||
                            window.location.href.includes("localhost")
                            ? "inputBorder"
                            : ""
                          }`}
                        title={`${translate("postal_code")}*`}
                        value={postcode}
                        onChange={(e) => handlePostalCodeChange(e.target.value)}
                      />
                      <OsnInputText
                        error={error === "gemeente" ? true : false}
                        className={`paper-field-gemeente ${window.location.href.includes("mijn.stad-gemeente.be") ||
                            window.location.href.includes("ma.ville-commune.be") ||
                            window.location.href.includes("localhost")
                            ? "inputBorder"
                            : ""
                          }`}
                        title={`${translate("mi_municipality")}*`}
                        value={gemeente}
                        readOnly={addressAutoFilled}
                        onChange={(e) => {
                          if (!addressAutoFilled) {
                            setGemeente(e.target.value);
                            setError("");
                          }
                        }}
                      />
                      {subMunicipalityOptions.length > 1 ? (
                        <div className="paper-field-deelgemeente">
                          <label className="address-select-label">{translate("ci_sub_municipality")}</label>
                          <Select
                            value={selectedSubMunicipality}
                            options={subMunicipalityOptions}
                            onChange={(option) => {
                              setSelectedSubMunicipality(option);
                              setDeelgemeente(option ? option.label : "");
                              setSelectedStreet(null);
                              setStreet("");
                              setError("");
                            }}
                            placeholder={translate("ci_sub_municipality")}
                            isClearable
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                borderColor: error === "deelgemeente" ? '#dc3545' : '#ced4da',
                              }),
                            }}
                          />
                        </div>
                      ) : (
                        <OsnInputText
                          error={error === "deelgemeente" ? true : false}
                          className={`paper-field-deelgemeente ${window.location.href.includes("mijn.stad-gemeente.be") ||
                              window.location.href.includes("ma.ville-commune.be") ||
                              window.location.href.includes("localhost")
                              ? "inputBorder"
                              : ""
                            }`}
                          title={`${translate("ci_sub_municipality")}`}
                          value={deelgemeente}
                          readOnly={addressAutoFilled && subMunicipalityOptions.length === 1}
                          onChange={(e) => {
                            if (!(addressAutoFilled && subMunicipalityOptions.length === 1)) {
                              setDeelgemeente(e.target.value);
                              setError("");
                            }
                          }}
                        />
                      )}
                    </div>
                    {/* Row 2: Street (typeahead), House number, Box */}
                    <div className="paper-version-row">
                      {addressAutoFilled ? (
                        <div className="paper-field-straat">
                          <label className="address-select-label">{translate("mi_street")}*</label>
                          <AsyncCreatableSelect
                            key={`street-${postcode}-${selectedSubMunicipality?.value || 'none'}`}
                            value={selectedStreet}
                            defaultOptions={streetOptions}
                            loadOptions={loadStreetOptions}
                            onChange={(option) => {
                              setSelectedStreet(option);
                              setStreet(option ? option.label : "");
                              setError("");
                            }}
                            placeholder={translate("mi_street")}
                            isClearable
                            formatCreateLabel={(inputValue) => `${inputValue}`}
                            noOptionsMessage={() =>
                              translate("no_results") || "No results"
                            }
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                borderColor: error === "street" ? '#dc3545' : '#ced4da',
                              }),
                            }}
                          />
                        </div>
                      ) : (
                        <OsnInputText
                          error={error === "street" ? true : false}
                          className={`paper-field-straat ${window.location.href.includes("mijn.stad-gemeente.be") ||
                              window.location.href.includes("ma.ville-commune.be") ||
                              window.location.href.includes("localhost")
                              ? "inputBorder"
                              : ""
                            }`}
                          title={`${translate("mi_street")}*`}
                          value={street}
                          onChange={(e) => {
                            setStreet(e.target.value);
                            setError("");
                          }}
                        />
                      )}
                      <OsnInputText
                        error={error === "housenumber" ? true : false}
                        className={`paper-field-huisnummer ${window.location.href.includes("mijn.stad-gemeente.be") ||
                            window.location.href.includes("ma.ville-commune.be") ||
                            window.location.href.includes("city-municipality.be") ||
                            window.location.href.includes("stadt-gemeinde.be") ||
                            window.location.href.includes("localhost")
                            ? "inputBorder"
                            : ""
                          }`}
                        title={`${translate("house_number")}*`}
                        value={houseNumber}
                        onChange={(e) => {
                          setHouseNumber(e.target.value);
                          setError("");
                        }}
                      />
                      <OsnInputText
                        error={error === "box" ? true : false}
                        className={`paper-field-bus ${window.location.href.includes("mijn.stad-gemeente.be") ||
                            window.location.href.includes("ma.ville-commune.be") ||
                            window.location.href.includes("city-municipality.be") ||
                            window.location.href.includes("stadt-gemeinde.be") ||
                            window.location.href.includes("localhost")
                            ? "inputBorder"
                            : ""
                          }`}
                        title={`${translate("box_no")}`}
                        value={bus}
                        onChange={(e) => {
                          setBus(e.target.value);
                          setError("");
                        }}
                      />
                    </div>
                  </div>
                }
                <div className="is-paper-version">
                  <input
                    type="checkbox"
                    id="is_paper_version_text2"
                    checked={isPaperVersionText2}
                    onChange={(e) => setIsPaperVersionText2(e.target.checked)}
                  />
                  <label htmlFor="is_paper_version_text2">
                    {translate("is_paper_version_text2")}
                  </label>
                </div>
                <div className="is-paper-version">
                  <input
                    type="checkbox"
                    id="is_paper_version_text3"
                    checked={isPaperVersionText3}
                    onChange={(e) => setIsPaperVersionText3(e.target.checked)}
                  />
                  <label htmlFor="is_paper_version_text3">
                    {translate("is_paper_version_text3")}
                  </label>
                </div>
              </>}
            <div className="following-municipality-select-wrapper">
              <div className="cities-label-container">
                <label className="municipality-label">
                  {translate(
                    "which_cities_and_or_municipalities_would_you_like_to_follow"
                  )} *
                </label>
              </div>
              <br />
              <br />
              {/* <DualListBox
                                    options={optionsForFollowingMunicipalities} // Pass the options array with value-label pairs
                                    onChange={(selected) => {
                                        // Explicit event handling for Safari
                                        const event = window.event || {};
                                        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
                                        if (isMac && event.type === 'mousedown') {
                                            event.preventDefault(); // Prevent Safari's default behavior
                                        }
                                        handleFollowingMunicipalityChange(selected);
                                    }}
                                    selected={municipalityFollowing}
                                    canFilter // Enable search filtering
                                    filterPlaceholder={translate('search_municipality')} // Add translation for filter placeholder

                                /> */}
              <CustomDualListBox
                options={optionsForFollowingMunicipalities}
                selected={municipalityFollowing}
                onChange={handleFollowingMunicipalityChange}
                highlightedValues={highlightedMunicipalityId ? [highlightedMunicipalityId] : []}
              />
              <label
                style={{ marginTop: "2px" }}
                className="multi_select_help_text"
              >
                {translate(
                  "to_multi_select_the_municipality_using_control_key"
                )}
              </label>
            </div>

            <div className="following-municipality-select-wrapper">
              <div className="cities-label-container">
                <label className="municipality-label">
                  {translate("which_provinces_would_you_like_to_follow")}
                </label>
              </div>
              <br />
              <br />
              {/* <DualListBox
                                    options={optionsForFollowingProvinces} // Pass provinces instead of municipalities
                                    onChange={(selected) => {
                                        const event = window.event || {};
                                        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
                                        if (isMac && event.type === 'mousedown') {
                                            event.preventDefault();
                                        }
                                        handleFollowingProvinceChange(selected);
                                    }}
                                    selected={provinceFollowing} // Now represents selected provinces
                                    canFilter
                                    filterPlaceholder={translate('search_province')}
                                /> */}
              <CustomDualListBox
                options={optionsForFollowingProvinces}
                selected={provinceFollowing}
                onChange={handleFollowingProvinceChange}
              />
            </div>

            <label className="multi_select_help_text">
              {translate("to_multi_select_the_municipality_using_control_key")}
            </label>

            <div className="cross_platform_note">
              <p>{translate('cross_platform_note')}</p>
              <a href="https://www.promonetwerk.be" target="_blank" rel="noopener noreferrer">promonetwerk.be</a>
              <span> · </span>
              <a href="https://www.catalogusnetwerk.be" target="_blank" rel="noopener noreferrer">catalogusnetwerk.be</a>
            </div>
            <div className="login_register_button">
              {isRegistering ? (
                <div className="loader"></div>
              ) : (
                <div
                  onClick={() => isUpdateFollowsMode ? updateFollowsHandler() : extraRegisterHandler()}
                  className="login_button"
                >
                  {isUpdateFollowsMode
                    ? (translate("save_selections") || "Selecties opslaan")
                    : translate("register")}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="innerLogin">
            {loginType === "login" ? (
              forgotPassword ? (
                <div className="login">
                  <OsnInputText
                    className={`email ${
                      window.location.href.includes("mijn.stad-gemeente.be") ||
                      window.location.href.includes("ma.ville-commune.be") ||
                      window.location.href.includes("city-municipality.be") ||
                      window.location.href.includes("stadt-gemeinde.be") ||
                      window.location.href.includes("localhost")
                        ? "inputBorder"
                        : ""
                    }`}
                    icon="Mail"
                    title={translate("email")}
                    onKeyDown={(e) => e.keyCode === 13 && loginHandler()}
                    onChange={(e) => setForgotEmail(e.target.value)}
                  />
                  <span
                    className="forgot_password"
                    onClick={() => setForgotPassword(false)}
                  >
                    {translate("password_remember")}
                  </span>
                  <div className="login_button" onClick={() => forgotHandler()}>
                    {translate("send")}
                  </div>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <div className="slider-container">
                    <Slider {...sliderSettings}>
                      {sliderImages.map((imageUrl, index) => (
                        <div key={index}>
                          <img
                            src={imageUrl}
                            alt={`trees-info-${index + 1}`}
                          />
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              ) : (
                <div className="login">
                  <OsnInputText
                    value={LoginEmailUsername}
                    error={error === "login" ? true : false}
                    className={`email ${
                      window.location.href.includes("mijn.stad-gemeente.be") ||
                      window.location.href.includes("ma.ville-commune.be") ||
                      window.location.href.includes("city-municipality.be") ||
                      window.location.href.includes("stadt-gemeinde.be") ||
                      window.location.href.includes("localhost")
                        ? "inputBorder"
                        : ""
                    }`}
                    icon="Mail"
                    title={translate("email_or_username")}
                    onKeyDown={(e) => e.keyCode === 13 && loginHandler()}
                    onChange={(e) => {
                      setLoginEmailUsername(e.target.value);
                      setError("");
                    }}
                  />
                  <br />
                  <div className="input-container">
                    <OsnInputText
                      error={error === "login" ? true : false}
                      className={`password ${
                        window.location.href.includes(
                          "mijn.stad-gemeente.be"
                        ) ||
                        window.location.href.includes("ma.ville-commune.be") ||
                        window.location.href.includes("city-municipality.be") ||
                        window.location.href.includes("stadt-gemeinde.be") ||
                        window.location.href.includes("localhost")
                          ? "inputBorder"
                          : ""
                      }`}
                      cta_icon={viewPassword ? "Hidden" : "Visible"}
                      cta_click={() => setViewPassword(!viewPassword)}
                      icon="Locked"
                      title={translate("password")}
                      type={viewPassword ? "text" : "password"}
                      onKeyDown={(e) => e.keyCode === 13 && loginHandler()}
                      onChange={(e) => {
                        setLoginPassword(e.target.value);
                        setError("");
                      }}
                    />
                    <span id="passwordIcon">
                      <Icon
                        name={viewPassword ? "PasswordShow" : "PasswordHide"}
                        onClick={() => setViewPassword(!viewPassword)}
                      />
                    </span>
                  </div>

                  <span
                    className="forgot_password"
                    onClick={() => setForgotPassword(true)}
                  >
                    {translate("forgot_password")}
                  </span>
                  <span className="error_message">
                    {error === "login" && translate("wrong_login_data")}
                  </span>
                  <div className="login_button" onClick={() => loginHandler()}>
                    {translate("log_in")}
                  </div>
                  <span
                    className="already_account"
                    onClick={() => {
                      setLoginType("register");
                      setRegisterEmail("");
                      setError("");
                    }}
                  >
                    {translate("i_dont_have_account")}
                  </span>
                  <div className="slider-container">
                    <Slider {...sliderSettings}>
                      {sliderImages.map((imageUrl, index) => (
                        <div key={index}>
                          <img
                            src={imageUrl}
                            alt={`trees-info-${index + 1}`}
                          />
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              )
            ) : (
              <div className="login_register">
                {/* <div className="login_type_buttons">
                                        <div onClick={() => { resetValues(); setUserType('consumer') }} className={`type_button ${userType === "consumer" ? 'active' : ''}`}>{translate('i_am_consumer')}</div>
                                        <div onClick={() => { resetValues(); setUserType('business') }} className={`type_button ${userType === "business" ? 'active' : ''}`}>{translate('i_am_entrepreneur')}</div>
                                    </div> */}

                {/* {userType === 'consumer' ? */}
                <React.Fragment>
                  <OsnInputText
                    value={registerEmail}
                    error={error === "email"}
                    className={`email ${
                      window.location.href.includes("mijn.stad-gemeente.be") ||
                      window.location.href.includes("ma.ville-commune.be") ||
                      window.location.href.includes("city-municipality.be") ||
                      window.location.href.includes("stadt-gemeinde.be") ||
                      window.location.href.includes("localhost")
                        ? "inputBorder"
                        : ""
                    }`}
                    icon="Mail"
                    title={translate("email")}
                    onChange={(e) => {
                      setRegisterEmail(e.target.value);
                      setError("");
                    }}
                  />

                  <div className="input-container">
                    <span
                      className="password-icon"
                      onClick={() => setViewPassword1(!viewPassword1)}
                    >
                      <Icon
                        name={viewPassword1 ? "PasswordShow" : "PasswordHide"}
                      />
                    </span>
                    <OsnInputText
                      error={error === "password"}
                      cta_icon={viewPassword1 ? "Hidden" : "Visible"}
                      cta_click={() => setViewPassword1(!viewPassword1)}
                      className={`email ${
                        window.location.href.includes(
                          "mijn.stad-gemeente.be"
                        ) ||
                        window.location.href.includes("ma.ville-commune.be") ||
                        window.location.href.includes("city-municipality.be") ||
                        window.location.href.includes("stadt-gemeinde.be") ||
                        window.location.href.includes("localhost")
                          ? "inputBorder"
                          : ""
                      }`}
                      icon="Locked"
                      title={translate("password")}
                      type={viewPassword1 ? "text" : "password"}
                      onChange={(e) => {
                        setRegisterPassword(e.target.value);
                        setError("");
                      }}
                    />
                  </div>

                  <div className="input-container">
                    <span
                      className="password-icon"
                      onClick={() => setViewPassword2(!viewPassword2)}
                    >
                      <Icon
                        name={viewPassword2 ? "PasswordShow" : "PasswordHide"}
                      />
                    </span>
                    <OsnInputText
                      error={error === "repeat_password"}
                      cta_icon={viewPassword2 ? "Hidden" : "Visible"}
                      cta_click={() => setViewPassword2(!viewPassword2)}
                      className={`email ${
                        window.location.href.includes(
                          "mijn.stad-gemeente.be"
                        ) ||
                        window.location.href.includes("ma.ville-commune.be") ||
                        window.location.href.includes("city-municipality.be") ||
                        window.location.href.includes("stadt-gemeinde.be") ||
                        window.location.href.includes("localhost")
                          ? "inputBorder"
                          : ""
                      }`}
                      icon="Locked"
                      title={translate("password_repeat")}
                      type={viewPassword2 ? "text" : "password"}
                      onChange={(e) => {
                        setRegisterRepeatPassword(e.target.value);
                        setError("");
                      }}
                    />
                  </div>

                  <div
                    onClick={() => registerHandler()}
                    className="login_button_register"
                  >
                    {translate("next")}
                  </div>
                  <span
                    className="already_account"
                    onClick={() => setLoginType("login")}
                  >
                    {translate("i_already_have_account")}
                  </span>
                  <div className="slider-container">
                    <Slider {...sliderSettings}>
                      {sliderImages.map((imageUrl, index) => (
                        <div key={index}>
                          <img
                            src={imageUrl}
                            alt={`trees-info-${index + 1}`}
                          />
                        </div>
                      ))}
                    </Slider>
                  </div>
                </React.Fragment>
                {/* :
                                        <React.Fragment>
                                            <OsnInputText error={error === 'email' ? true : false} className="email" icon="Mail" title={translate('email')} onChange={(e) => { setRegisterEmail(e.target.value); setError('') }} />
                                            <OsnInputText error={error === 'password' ? true : false} cta_icon={viewPassword3 ? 'Hidden' : "Visible"} cta_click={() => setViewPassword3(!viewPassword3)} className="password" icon="Locked" title={translate('password')} type={viewPassword3 ? "text" : "password"} onChange={(e) => { setRegisterPassword(e.target.value); setError('') }} />
                                            <OsnInputText error={error === 'repeat_password' ? true : false} cta_icon={viewPassword4 ? 'Hidden' : "Visible"} cta_click={() => setViewPassword4(!viewPassword4)} className="password" icon="Locked" title={translate('password_repeat')} type={viewPassword4 ? "text" : "password"} onChange={(e) => { setRegisterRepeatPassword(e.target.value); setError('') }} />
                                            <OsnInputText error={error === 'enterprise' ? true : false} className="Business" icon="Entrepreneur" title={translate('your_enterprise_number')} onChange={(e) => { setRegisterEnterpriseNumber(e.target.value); setError('') }} />
                                            <OsnInputText error={error === 'establishment' ? true : false} className="password" icon="Groups" title={translate('your_establishment_number')} onChange={(e) => { setRegisterEstablishmentNumber(e.target.value); setError('') }} />
                                            <OsnInputText error={error === 'otp' ? true : false} cta_icon={viewPassword5 ? 'Hidden' : "Visible"} cta_click={() => setViewPassword5(!viewPassword5)} className="password" icon="Locked" title={translate('otp')} type={viewPassword5 ? "text" : "password"} onChange={(e) => { setRegisterOtp(e.target.value); setError('') }} />
                                            <span className="forgot_password">{translate('dont_have_otp_yet')}</span>
                                            <div onClick={() => registerHandler()} className="login_button">{translate('next')}</div>
                                            <span className="already_account" onClick={() => setLoginType("login")}>{translate('i_already_have_account')}</span>
                                        </React.Fragment> 
                                     */}
              </div>
            )}
          </div>
        )}
        {/* {loginType === 'login' &&
                    <div className="cread">
                        <p>{translate('logged_in_users_follow_their')} <span style={{ "color": "var(--pn)" }}>{translate('favorite_entrepreneurs')}</span> {translate('and_have_access_to')}</p>
                        <div className="cread-container" style={{ display: "flex", padding: "7px 25px", gap: "5px" }}>
                            <figure className={`${zoomIn ? 'zoom' : ''}`}>
                                <a target="_blank" href={require(`../assets/imgs/cread-gebruikers_${lang}.png`)}>
                                    <img src={require(`../assets/imgs/cread-gebruikers_${lang}.png`)} />
                                    <Icon name="Search" />
                                </a>
                            </figure>
                            <ul>
                                <li>{translate('promotions_that_will_be_offered_in_the_future')}</li>
                                <li>{translate('exceptional_offers_especially_for_loyal_customers')}</li>
                                <li>{translate('the_ability_to_create_smart_shopping_lists')} </li>
                            </ul>
                        </div>
                    </div>} */}
      </div>
      <div
        className="login_bg"
      ></div>
    </div>
  );
};

export default Login;
